class CnRGridItemDD {
    defaults = {
        target:".cnr-variants-dd",
        icons: true,
        title_transform:(title)=>title,
        variant_select:(product,variant, secondVariantImage)=>console.log("variant selected"),
        select_swatch:(swatches,variant)=>variant.featured_image.src
    }
    constructor(options) {
        this.config = {...this.defaults,...options};

        let style = document.createElement("style");
        style.type = "text/css";
        style.id="cnr-grid-item-dd";
        style.textContent = this.css();

        document.querySelector("head").appendChild(style);

        document.querySelectorAll(this.config.target).forEach(item=>this.render(item));


    }
    load_json(product_id,which) {
      try {
        let ret = JSON.parse(document.querySelector(`script.${which}[data-product-id="${product_id}"]`).textContent);
        return ret;
      } catch(e) {
        return []
      }
    }
    render(target) {
      let variants = this.load_json(target.dataset.productId,"product-variants").filter(variant=>variant.available);
      let alts = this.load_json(target.dataset.productId,"product-alts");
      let images = this.load_json(target.dataset.productId,"product-images");

      let swatches = alts.map((item,index)=>[item,images[index]]).filter(item=>item[0].startsWith("SWATCH"));
      if (variants.filter(item=>item.available).length<=1) {
        return;
      }


        let options = variants.map(variant=>`
        <li class="cnr-gidd-option body1" data-variant="${variant.id}">
            <span class="cnr-gidd-option-icon"><img class="cnr-gidd-option-image" alt="${variant.title}" src="${this.config.select_swatch(swatches,variant)}" width="32" height="32"></span>
            <span class="cnr-gidd-option-label body1 caps">${this.config.title_transform(variant.title)}</span>
        </li>`);
        target.innerHTML = `
        <ul class="cnr-gidd-selected-options">${options.join("")}</ul>
        <div class="cnr-gidd-option-button">
            <span class="cnr-gidd-selected-icon"><img alt="${variants[0].title}" class="cnr-gidd-option-image" src="${this.config.select_swatch(swatches,variants[0])}"></span>
            <span class="cnr-gidd-selected-label">${this.config.title_transform(variants[0].title)}</span>
            <i class="zmdi zmdi-chevron-down">&#x25bc;</i>
        </div>
        <input type="hidden" name="id" class="cnr-hidden-variant-id product-variant-id" value="${variants[0].id}">
        `;

        target.querySelector(".cnr-gidd-option-button").addEventListener("click",event=>{
            document.querySelectorAll(".cnr-variants-dd.active").forEach(button=>button.classList.remove("active"));
            target.classList.toggle("active");
            let options = document.querySelector(".cnr-gidd-selected-options");
            options.style.top = `0px`;

        });
        target.querySelectorAll(".cnr-gidd-option").forEach(li=>li.addEventListener("click",event=>{
            target.classList.remove("active");
            let variant = variants.find(variant=>variant.id==parseInt(li.dataset.variant));

            if (variant) {
                target.querySelector(".cnr-gidd-selected-icon img.cnr-gidd-option-image").src = li.querySelector("img").src;
                target.querySelector(".cnr-gidd-selected-label").textContent = this.config.title_transform(variant.title);
                target.querySelector(".cnr-hidden-variant-id").value=variant.id;
            }

             let variantMainImage = variant.featured_image.src
             let productAllVariantsImages = images
             let indexOfTheVariantImage = productAllVariantsImages.findIndex(imageUlr => imageUlr == variantMainImage)
             let secondVariantImage = productAllVariantsImages[indexOfTheVariantImage + 1]
            this.config.variant_select(target.getAttribute("data-product-id"), variant, secondVariantImage);
        }));
        document.querySelector(".main-content").addEventListener("click",event=>{
  		let node = event.srcElement;




  		while (node && node.parentNode!=null) {

  			try {
  				if (node.parentNode.classList && node.classList.contains("cnr-gidd-option-button")) {
  					return;
  				}
  				if (node.parentNode.classList && node.classList.contains("cnr-gidd-selected-options")) {
  					break;
  				}
  			} catch(e) {
  				console.error(e);
  			}

  			node = node.parentNode;
  		}
        document.querySelectorAll(".cnr-variants-dd.active").forEach(button=>button.classList.remove("active"));
	});
    }
    css() {
        return `
            ${this.config.target} {
                position: relative;
                display:block;
                margin-top:8px;
                margin-bottom:8px;
            }
            ${this.config.target} .cnr-gidd-selected-options  {
                display: none;
            }
            ${this.config.target}.active.what .cnr-gidd-option-button  {
              display:none;
            }
            .cnr-gidd-option-button, .cnr-gidd-option {
              display: flex;
              flex-direction: row;
              align-content:center;
              align-items:center;
              padding-right: 16px;
              padding-top: 8px;
              padding-bottom:8px;
              cursor: pointer;
              position: relative;
            }
            ${this.config.target}.active .cnr-gidd-selected-options  {
                width: 100%;
                display: block;
                position: absolute;
                top: 0px;
                left: 0px;
                z-index: 22222900000;
                background-color: #ffff;
                border: 1px solid #cecece;
                border-radius: 3px;
                max-height: 450px;
                overflow: auto;
            }
            .cnr-gidd-option-icon, .cnr-gidd-selected-icon, .cnr-gidd-option-image {
                width: 24px!important;
                height: 24px!important;
                border-radius: 50%!important;
                margin-right:16px;
                margin-left: 8px;
                
            }
            
            .cnr-gidd-option-button {
                
                background-color: #fff;
                color: #616161;
                border: 1px solid #cecece;
                border-radius: 3px;
                cursor: pointer;
                width: 300px;
                margin-left: auto;
                margin-right: auto;
                text-align: left;
             }
            .zmdi-chevron-down {
                position: absolute;
                right: 10px;
                top: 12px;
                width: 20px;
                content: "\u25bc";
            }
            cnr-gidd-option-button .cnr-gidd-option-label {
                color: #2b463666;
                font-weight: 700;
             
            }
            cnr-gidd-option-button .cnr-gidd-option-label::after     {
                content: "\u25bc";
            }

            @media only screen and (max-width: 768px) {
                .cnr-gidd-option-label {
                    font-size: 14px;
                }
            }

        `;
    }
}
